import * as types from './types';

const initialState = {
  stats: {
    total_calls: 0,
    completed_calls: 0,
    failed_calls: 0,
    voicemail_calls: 0,
    pending_calls: 0,
    contact_rate: 0,
    avg_duration_seconds: 0,
    success_rate: 0,
    total_promises: 0,
    minutes_used: 0,
    minutes_limit: 0
  },
  statsLoading: false,
  calls: [],
  callsLoading: false,
  pagination: { total: 0, pages: 0, page: 1, limit: 10 },
  filters: {
    search: '',
    invoiceSearch: '', // sincronizado con search desde el buscador unificado
    dateFrom: '',
    dateTo: '',
    status: '',
    outcome: '',
    flag: '',
    sortBy: '',
    sortOrder: 'DESC'
  },
  transcript: null,
  transcriptLoading: false,
  selectedCall: null,
  exporting: false
};

const voiceDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.VOICE_DASHBOARD_FETCH_STATS_REQUEST:
      return { ...state, statsLoading: true };
    case types.VOICE_DASHBOARD_FETCH_STATS_SUCCESS:
      return { ...state, statsLoading: false, stats: action.payload };
    case types.VOICE_DASHBOARD_FETCH_STATS_ERROR:
      return { ...state, statsLoading: false };

    case types.VOICE_DASHBOARD_FETCH_CALLS_REQUEST:
      return { ...state, callsLoading: true };
    case types.VOICE_DASHBOARD_FETCH_CALLS_SUCCESS:
      return {
        ...state,
        callsLoading: false,
        calls: action.payload.data,
        pagination: action.payload.pagination
      };
    case types.VOICE_DASHBOARD_FETCH_CALLS_ERROR:
      return { ...state, callsLoading: false };

    case types.VOICE_DASHBOARD_FETCH_TRANSCRIPT_REQUEST:
      return { ...state, transcriptLoading: true, transcript: null };
    case types.VOICE_DASHBOARD_FETCH_TRANSCRIPT_SUCCESS:
      return { ...state, transcriptLoading: false, transcript: action.payload };
    case types.VOICE_DASHBOARD_FETCH_TRANSCRIPT_ERROR:
      return { ...state, transcriptLoading: false };
    case types.VOICE_DASHBOARD_CLEAR_TRANSCRIPT:
      return { ...state, transcript: null };

    case types.VOICE_DASHBOARD_SET_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };
    case types.VOICE_DASHBOARD_SET_PAGE:
      return {
        ...state,
        pagination: { ...state.pagination, page: action.payload }
      };

    case types.VOICE_DASHBOARD_EXPORT_CSV_REQUEST:
      return { ...state, exporting: true };
    case types.VOICE_DASHBOARD_EXPORT_CSV_SUCCESS:
    case types.VOICE_DASHBOARD_EXPORT_CSV_ERROR:
      return { ...state, exporting: false };

    case types.VOICE_DASHBOARD_SET_SELECTED_CALL:
      return { ...state, selectedCall: action.payload };

    case types.VOICE_DASHBOARD_SET_CALLS_LOADING:
      return { ...state, callsLoading: action.payload };

    default:
      return state;
  }
};

export default voiceDashboardReducer;



// WEBPACK FOOTER //
// ./src/containers/voice-agent-dashboard/store/reducer.js